<template>
  <h1 class="text-h4 mt-5 mb-10"><slot name="default"></slot></h1>
</template>

<script>
export default {
  name: 'PageHeading'
}
</script>
